import type {
  ExpansionDefinition,
  ExpansionScenario,
  ExpansionScenarioMode,
} from '../../../types/expansions';
import { ALIEN_INVASION_SOURCE_WARNING } from './source';
import { alienInvasionScenarios } from './scenarios';
import type { AlienScenarioDefinition, AlienScenarioId } from './types';

export const ALIEN_INVASION_EXPANSION_ID = 'on-mars-alien-invasion';
export const ON_MARS_GAME_ID = 'on-mars';

const MODE_MAP: Record<AlienScenarioId, ExpansionScenarioMode> = {
  invasion: 'oneVsMany',
  outbreak: 'cooperative',
  blackout: 'cooperative',
  monolith: 'solo',
};

const ORDER: Record<AlienScenarioId, number> = {
  invasion: 1,
  outbreak: 2,
  blackout: 3,
  monolith: 4,
};

/**
 * Adapter: AlienScenarioDefinition → ExpansionScenario (shared expansion system).
 * Scenario IDs stay as Layer B ids: invasion | outbreak | blackout | monolith.
 * contentStatus is `partial` (Preview v28 draft) — never `awaiting-instruction`.
 */
export function toExpansionScenario(
  scenario: AlienScenarioDefinition
): ExpansionScenario {
  return {
    id: scenario.id,
    expansionId: ALIEN_INVASION_EXPANSION_ID,
    title: scenario.title,
    subtitle: scenario.mode,
    description: `${scenario.playerCount} · ${scenario.difficulty}`,
    playerCount: scenario.playerCount,
    mode: MODE_MAP[scenario.id],
    recommendedOrder: ORDER[scenario.id],
    sectionIds: [...scenario.sectionIds],
    contentStatus: 'partial',
  };
}

export const alienInvasionExpansionScenarios: ExpansionScenario[] =
  alienInvasionScenarios.map(toExpansionScenario);

export const alienInvasionExpansion: ExpansionDefinition = {
  id: ALIEN_INVASION_EXPANSION_ID,
  gameId: ON_MARS_GAME_ID,
  title: 'ON MARS: Alien Invasion',
  shortTitle: 'Alien Invasion',
  description:
    'Cztery odrębne rozdziały zmieniające tryb gry. Wymaga znajomości zasad podstawowych ON MARS.',
  type: 'scenarioCollection',
  enabledByDefault: false,
  requiresBaseGame: true,
  selectionMode: 'singleScenario',
  scenarios: alienInvasionExpansionScenarios,
  contentStatus: 'partial',
};

export function isAlienScenarioId(value: string): value is AlienScenarioId {
  return (
    value === 'invasion' ||
    value === 'outbreak' ||
    value === 'blackout' ||
    value === 'monolith'
  );
}

export function getAlienInvasionScenario(
  scenarioId: string
): AlienScenarioDefinition | undefined {
  return alienInvasionScenarios.find((scenario) => scenario.id === scenarioId);
}

export { ALIEN_INVASION_SOURCE_WARNING };
